import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT;

export const getCustomer = createAsyncThunk(
    'customer/get-customer', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.post(`${API_URL}/customer/get-customer`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching customer:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const getCustomerVehicle = createAsyncThunk(
    'customer/get-customer-vehicle', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.post(`${API_URL}/customer/get-customer-vehicle`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching customer vehicle:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

const customerSlice = createSlice({
    name: 'customer',
    initialState: {
        customer: [],
        customer_vehicle: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getCustomer.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getCustomer.fulfilled, (state, action) => {
            state.isLoading = false;
            state.customer = action.payload;
        })
        .addCase(getCustomer.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(getCustomerVehicle.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getCustomerVehicle.fulfilled, (state, action) => {
            state.isLoading = false;
            state.customer_vehicle = action.payload;
        })
        .addCase(getCustomerVehicle.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
    },
});

export default customerSlice.reducer;